// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import toast from 'react-hot-toast'
import moment from 'moment'
// ** Axios Imports
import axios from 'axios'

export const getData = createAsyncThunk('login/getData', async params => {
  const response = await axios.post('https://api.fntpf.ir/admin/getrequests', params)
  return {
    params,
    data: response.data.invoices,
    allData: response.data.allData,
    totalPages: response.data.total
  }
})

export const sendToken = createAsyncThunk('login/sendToken', async params => {
  const response = await axios.post('https://api.fntpf.ir/login', params)
  if (response.data.login) toast.success(response.data.message)
  else toast.error(response.data.error)
  return response.data
})

export const verification = createAsyncThunk('login/verification', async params => {
  const response = await axios.post('https://api.fntpf.ir/confirm', params)
  if (response.data.login) {
    console.log(moment().unix())
    localStorage.setItem('userData', JSON.stringify(response.data.user))
    localStorage.setItem('stamp', moment().unix())
    if (response.data.user.account_type !== 'admin') {
      toast.error('شما دسترسی ندارید')
    } else toast.success(response.data.message)
  } else toast.error(response.data.error)
    return response.data
})

export const loginSlice = createSlice({
  name: 'login',
  initialState: {
    jwt: '',
    userInfo: {},
    tokenStatus: false
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getData.fulfilled, (state, action) => {
      state.jwt = action.payload.data
      state.userInfo = action.payload.allData
    }).addCase(sendToken.fulfilled, (state, action) => {
      state.tokenStatus = action.payload
    }).addCase(verification.fulfilled, (state, action) => {
      state.userInfo = action.payload
    })
  }
})

export default loginSlice.reducer
